var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0624 26.1664C38.0624 37.9037 24.0003 42.1611 24.0003 42.1611C24.0003 42.1611 9.94014 37.9056 9.94014 26.1664C9.94014 14.4271 9.42748 13.5099 10.5584 12.3815C11.6854 11.2514 22.1571 7.60107 24.0003 7.60107C25.8454 7.60107 36.3133 11.242 37.4442 12.3815C38.5731 13.5193 38.0624 14.429 38.0624 26.1664Z",
    stroke: "#F79009",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6243 29.4731H21.377C19.9388 29.4731 18.7715 28.3075 18.7715 26.869V23.9229C18.7715 22.4845 19.9388 21.3188 21.377 21.3188H26.6243C28.0624 21.3188 29.2279 22.4845 29.2279 23.9229V26.869C29.2279 28.3075 28.0624 29.4731 26.6243 29.4731Z",
    stroke: "#F79009",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1321 21.37V19.4999C27.1091 17.7701 25.6902 16.3859 23.9603 16.4065C22.2649 16.427 20.896 17.7925 20.8672 19.4868V21.37",
    stroke: "#F79009",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLock);
export default __webpack_public_path__ + "static/media/shield_lock.15ca4a53f9ea29acec4b6e2aa9e2437f.svg";
export { ForwardRef as ReactComponent };